// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { useRequest } from "redux-query-react";
import { useSelector } from 'react-redux';
import { isEqual } from "lodash";
import * as runtime from '../runtime';
import { objectToHash } from "common/object-helper";
import { ManagerFromJSON, } from '../models';
/**
 * Get manager by id
 * Get manager by id
 */
export function getManagerByIdRaw(requestParameters, requestConfig = {}) {
    if (requestParameters.id === null || requestParameters.id === undefined) {
        throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getManagerById.');
    }
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/manager/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))) + queryString,
        meta,
        update: requestConfig.update || {
            Manager: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'GET',
            headers: headerParameters,
        },
        body: queryParameters,
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = ManagerFromJSON(body);
            let key = "";
            if (requestParameters.id) {
                key = `${key}${requestParameters.id}`;
            }
            return { Manager: { [key]: objResponse } };
        }
    };
    config.queryKey = requestConfig.queryKey || `GetManagerById-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Get manager by id
* Get manager by id
*/
/**
 * Use this selector to get a reference to a single Manager matching the id
 * @param id Id of the Manager
 * @returns The Manager object
 */
export const useManagerByIdSelector = (id) => {
    let key = "";
    if (id) {
        key = `${key}${id}`;
    }
    return useSelector((state) => state.entities.Manager[key], isEqual);
};
/**
 * Request hook for a single Manager. Beware, this should not be called without a valid id ***WIP***
 * @param id id of the Manager
 * @returns an array containing the data, query state, and a call for refresh
 * (note : refresh shouldn't be necessary, update to the state should be handle by mutators)
 */
export const useGetManagerById = (requestParameters, customQueryConfig) => {
    const [querystate, forceRefresh] = useRequest(getManagerByIdRaw(requestParameters, customQueryConfig));
    return [
        useManagerByIdSelector(requestParameters.id),
        querystate,
        forceRefresh
    ];
};
export function getManagerById(requestParameters, requestConfig) {
    return getManagerByIdRaw(requestParameters, requestConfig);
}
